/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconButtonTheme, IconButtonVariantTheme, SternumTheme } from '@sternum/ui';

import { Colors } from '../constants';

import { sizes } from './shared';

export function lightPrimaryTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: Colors.BrandBlueLightest,
    textColor: Colors.BrandBlue,
    borderRadius: '50%',
    border: 'none',

    hoverBackgroundColor: Colors.BrandBlueMiddle,
    hoverTextColor: Colors.White,
    hoverBorderRadius: '50%',
    hoverBorder: 'none',

    disabledBackgroundColor: Colors.GreyDarkerMiddle,
    disabledTextColor: Colors.White,
    disabledBorderRadius: '50%',
    disabledBorder: 'none',

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function lightSecondaryTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: 'transparent',
    textColor: Colors.DarkerText,
    borderRadius: '6px',
    border: `1px solid ${Colors.GreyDarker}`,

    hoverBackgroundColor: Colors.Light,
    hoverTextColor: Colors.DarkerText,
    hoverBorderRadius: '6px',
    hoverBorder: `1px solid ${Colors.Light}`,

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkerMiddle,
    disabledBorderRadius: '6px',
    disabledBorder: `1px solid ${Colors.GreyDarkerMiddle}`,

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function lightTertiaryMainTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: `transparent`,
    textColor: Colors.BrandBlue,
    border: 'none',

    hoverBackgroundColor: `transparent`,
    hoverTextColor: Colors.BrandBlueMiddle,
    hoverBorder: 'none',

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkerMiddle,
    disabledBorder: 'none',

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function lightTertiarySecondTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: 'transparent',
    textColor: Colors.DarkerText,
    border: 'none',

    hoverBackgroundColor: 'transparent',
    hoverTextColor: Colors.BrandBlueMiddle,
    hoverBorder: 'none',

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkerMiddle,
    disabledBorder: 'none',

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function lightTertiaryThirdTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: 'transparent',
    textColor: Colors.GreyDarker,
    border: 'none',

    hoverBackgroundColor: 'transparent',
    hoverTextColor: Colors.DarkerText,
    hoverBorder: 'none',

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkerMiddle,
    disabledBorder: 'none',

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function SBOMLightIconButtonTheme(theme: SternumTheme): Partial<IconButtonTheme> {
  return {
    primary: lightPrimaryTheme(theme),
    secondary: lightSecondaryTheme(theme),
    // these variants are defined in theme/button/button.d.ts
    'tertiary-main': lightTertiaryMainTheme(theme),
    'tertiary-second': lightTertiarySecondTheme(theme),
    'tertiary-third': lightTertiaryThirdTheme(theme),
  };
}
